import type { ReactNode } from "react";
import { useLayoutEffect, useRef, useState } from "react";

export const AnimatedHeight = ({ children }: { children: ReactNode }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number | undefined>(undefined);

  useLayoutEffect(() => {
    if (contentRef.current) {
      setHeight(contentRef.current.offsetHeight);
    }
  });

  return (
    <div
      ref={containerRef}
      style={{
        height: height !== undefined ? `${height}px` : "auto",
        transition: "height 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        overflow: "hidden",
      }}
      aria-live="polite"
    >
      <div ref={contentRef}>{children}</div>
    </div>
  );
};
